import { app } from '../../../app';

class ResetPasswordVerifyService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    resetPassword(appKey,resetKey,newPassword) {
        return this.$http
            .get(` app/rest/loginSAMLWeb/resetappaccountpwd/${appKey}?rkey=${resetKey}&pwd=${newPassword}`)
            .then((response) => response.data);
    }
}

app.service('ResetPasswordVerifyService', ResetPasswordVerifyService);



// WEBPACK FOOTER //
// ./src/portal/states/public/reset-password-verify/reset-password-verify.service.js